import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ExtAuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionIdMatch = hash.match(/session_id=([^&]+)/);

    if (!sessionIdMatch) {
      navigate('/login', { replace: true });
      return;
    }

    const sessionId = sessionIdMatch[1];

    (async () => {
      try {
        // Exchange session for a one-time code the extension can use
        const res = await axios.post(`${API}/auth/ext-code`, { session_id: sessionId });
        const code = res.data.code;
        // Show the code to the user
        document.title = `HONEYPOT_EXT_CODE_${code}`;
        // Store code for display
        const el = document.getElementById('ext-code');
        if (el) el.textContent = code;
        const statusEl = document.getElementById('ext-status');
        if (statusEl) statusEl.textContent = 'Enter this code in the Honey Pot extension popup:';
      } catch (err) {
        console.error('Ext auth failed:', err);
        const statusEl = document.getElementById('ext-status');
        if (statusEl) statusEl.textContent = 'Authentication failed. Please try again.';
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center p-6">
      <div className="text-center max-w-sm">
        <div className="w-12 h-12 rounded-xl bg-amber-500/20 flex items-center justify-center mx-auto mb-4">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2.5"><polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"/></svg>
        </div>
        <p className="text-sm text-zinc-400 mb-4" id="ext-status">Authenticating...</p>
        <div className="bg-[#121214] border border-amber-500/20 rounded-xl p-6 mb-4">
          <p className="text-4xl font-mono font-black text-amber-500 tracking-[0.3em]" id="ext-code" data-testid="ext-auth-code">
            <span className="w-6 h-6 border-2 border-amber-500 border-t-transparent rounded-full animate-spin inline-block" />
          </p>
        </div>
        <p className="text-xs text-zinc-600">This code expires in 5 minutes. You can close this tab after entering it.</p>
      </div>
    </div>
  );
}
